import Icon from '../components/Icon.vue'

Icon.register({
  'user-lock': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M320 320C320 308.9 323.1 298.6 328.1 289.5 323.3 289 318.6 288 313.6 288H296.9C274.7 298.2 250 304 224 304S173.4 298.2 151.1 288H134.4C60.2 288 0 348.2 0 422.4V464C0 490.5 21.5 512 48 512H328.9C323.4 502.5 320 491.7 320 480V320zM224 256C294.7 256 352 198.7 352 128S294.7 0 224 0 96 57.3 96 128 153.3 256 224 256zM608 288H576V240C576 195.8 540.2 160 496 160S416 195.8 416 240V288H384C366.3 288 352 302.3 352 320V480C352 497.7 366.3 512 384 512H608C625.7 512 640 497.7 640 480V320C640 302.3 625.7 288 608 288zM528 288H464V240C464 222.4 478.4 208 496 208S528 222.4 528 240V288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-lock.js
// module id = Sd7c
// module chunks = 144